<template>
  <div class="bulkbar" :class="{ 'bulkbar--selecting': selected.length > 0 }">
    <template v-if="selected.length">
      <span class="bulkbar__count" data-count="selected">
        <v-icon small color="#2d8659">mdi-checkbox-multiple-marked-outline</v-icon>
        {{ selectedText }}
        <span v-if="hiddenCount" class="bulkbar__hidden" data-count="hidden">({{ hiddenText }})</span>
      </span>
      <v-btn class="btn-green" data-action="print-selected" @click="printOpen = true">
        <v-icon left>mdi-printer-outline</v-icon>Imprimă etichete
      </v-btn>
      <v-btn text color="#44574e" data-action="clear-selection" @click="$emit('clear-selection')">
        <v-icon left>mdi-close</v-icon>Deselectează
      </v-btn>
      <span class="bulkbar__spacer" />
    </template>
    <template v-else-if="canManage">
      <span class="bulkbar__hint">Bifați echipamente pentru a le imprima etichetele QR.</span>
      <span class="bulkbar__spacer" />
    </template>
    <span v-else class="bulkbar__spacer" />

    <v-btn v-if="canManage" outlined color="#2d8659" :to="{ path: '/inventariere' }" data-action="inventariere">
      <v-icon left>mdi-clipboard-check-multiple-outline</v-icon>Inventariere
    </v-btn>
    <v-btn v-if="canManage" outlined color="#2d8659" data-action="import" @click="importOpen = true">
      <v-icon left>mdi-database-import-outline</v-icon>Import Excel
    </v-btn>
    <v-btn outlined color="#2d8659" :loading="exporting" data-action="export" @click="exportExcel">
      <v-icon left>mdi-microsoft-excel</v-icon>Export Excel
    </v-btn>

    <StickerPrintDialog v-model="printOpen" :items="selected" />
    <ImportEquipmentDialog v-if="canManage" v-model="importOpen" @imported="$emit('imported', $event)" />
  </div>
</template>

<script>
// Echipamente: actions on the selected rows (QR stickers) and on the whole list (Excel export / import)
import StickerPrintDialog from "@/components/stickers/StickerPrintDialog.vue";
import ImportEquipmentDialog from "./ImportEquipmentDialog.vue";
import { exportEquipments, blobErrorMessage } from "./bulkApi";
import { ITEM_EDITOR_ROLES } from "@/config/periferice";
import { amount } from "@/helper/plural";

export default {
  name: "EquipmentBulkBar",
  components: { StickerPrintDialog, ImportEquipmentDialog },
  props: {
    // table rows ticked on the page, in the order to print
    selected: { type: Array, default: () => [] },
    // how many of them the current department / search filter hides (they are still printed)
    hiddenCount: { type: Number, default: 0 },
    // the page's filters, so the export has exactly the rows on screen
    department: { type: String, default: "" },
    search: { type: String, default: "" },
  },
  data() {
    return {
      printOpen: false,
      importOpen: false,
      exporting: false,
    };
  },
  computed: {
    selectedText() {
      return amount(this.selected.length, "echipament selectat", "echipamente selectate");
    },
    hiddenText() {
      return this.hiddenCount === 1 ? "1 nu este afișat acum" : `${this.hiddenCount} nu sunt afișate acum`;
    },
    // server EQUIPMENT_MANAGERS
    canManage() {
      const user = this.$store.getters.getUser || {};
      return ITEM_EDITOR_ROLES.includes(user.role);
    },
  },
  methods: {
    async exportExcel() {
      this.exporting = true;
      try {
        await exportEquipments({ department: this.department, search: this.search });
      } catch (e) {
        this.$emit("error", await blobErrorMessage(e, "Exportul nu a reușit. Încercați din nou."));
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped>
.bulkbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--line-soft, #e6ede9);
  background: #fff;
}
.bulkbar--selecting {
  background: var(--mint-50, #f2f8f4);
}
.bulkbar__hidden {
  font-weight: 400;
  color: var(--ink-3, #5f6f67);
}
.bulkbar__count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: var(--ink, #13221c);
}
.bulkbar__hint {
  color: var(--ink-3, #5f7068);
  font-size: 0.92rem;
}
.bulkbar__spacer {
  flex: 1 1 auto;
}
@media (max-width: 600px) {
  .bulkbar {
    padding: 10px 14px;
  }
  .bulkbar__hint {
    display: none;
  }
}
</style>
